import { Injectable } from '@angular/core';

@Injectable()
export class RuntimeConfigService {
  private config: { apiBaseUrl?: string; bypassApiBaseUrl?: string; bypassPaths?: any; conflictBucketApiBaseUrl?: string; conflictBucketApiPath?: string } = {};

  /** Values from conflict-bucket API; bypassPaths are not read from runtime-config.json. */
  private backendBypassBaseUrl = '';
  private backendBypassPaths: string[] = [];

  load(): Promise<void> {
    const runtimeConfigUrl = new URL('assets/runtime-config.json', document.baseURI).href;

    return fetch(runtimeConfigUrl, {
      cache: 'no-store',
      credentials: 'omit'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('runtime-config.json not found or unreadable');
        }
        return response.json();
      })
      .then((data) => {
        if (data && typeof data === 'object') {
          this.config = data;
        }
      })
      .catch((error) => {
        this.config = {};
        console.warn('Failed to load runtime config; using defaults.', error);
      });
  }

  getApiBaseUrl(): string {
    const value = this.config && typeof this.config.apiBaseUrl === 'string'
      ? this.config.apiBaseUrl.trim()
      : '';
    return value;
  }

  getBypassApiBaseUrl(): string {
    const value = this.config && typeof this.config.bypassApiBaseUrl === 'string'
      ? this.config.bypassApiBaseUrl.trim()
      : '';
    return value;
  }

  /** Same POST style as other APIs, e.g. `App_config/ajax_get_conflict_bucket`. Leave empty to disable fetch. */
  getConflictBucketApiPath(): string {
    const value = this.config && typeof (this.config as any).conflictBucketApiPath === 'string'
      ? (this.config as any).conflictBucketApiPath.trim()
      : '';
    return value;
  }

  /** Dedicated base URL only for conflict-bucket fetch (keeps bypass base coming from conflict-bucket response). */
  getConflictBucketApiBaseUrl(): string {
    const value = this.config && typeof (this.config as any).conflictBucketApiBaseUrl === 'string'
      ? (this.config as any).conflictBucketApiBaseUrl.trim()
      : '';
    return value;
  }

  /** Replaces bypass paths (and optional bypass base) from conflict-bucket response. */
  applyBackendConflictBucket(bypassApiBaseUrl: string, bypassPaths: string[]) {
    this.backendBypassBaseUrl = (bypassApiBaseUrl || '').trim();
    this.backendBypassPaths = !Array.isArray(bypassPaths) ? [] : bypassPaths
      .filter((x) => typeof x === 'string')
      .map((x) => x.trim().replace(/^\/+/, '').replace(/\/{2,}/g, '/'))
      .filter(Boolean);
  }

  getEffectiveBypassApiBaseUrl(): string {
    return this.backendBypassBaseUrl || this.getBypassApiBaseUrl();
  }

  /** Bypass paths from conflict-bucket API only (replaces any static config). */
  getMergedBypassPaths(): string[] {
    const n = (s: string) => s.trim().replace(/^\/+/, '').replace(/\/{2,}/g, '/');
    return Array.from(new Set(this.backendBypassPaths.map(n).filter(Boolean)));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2154308336/src/src/app/shared/services/runtime-config.service.ts